<template>
  <span class="app-version grey--text caption px-1">
    SmartPhone Ver. {{ appVersion }}
  </span>
</template>

<script>
import pkg from '@/../package.json'

export default {
  name: 'AppVersion',
  computed: {
    appVersion() {
      return pkg.version
    },
  },
}
</script>

<style lang="scss" scoped>
.app-version {
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>
